export default "__VITE_ASSET__DkiTMJaL__"